import { QuizData } from "@/models/h5p.model";
import { api } from "../api-config/setup";

export class H5pRest {
  static classroomId = localStorage.getItem("classId") ?? undefined;

  static async getUserData(id: string, courseId: string): Promise<any> {
    const url = `/xapi/${id}/courses/${courseId}/userdata`;
    return await api()
      .get(url, {
        params: { classroomId: H5pRest.classroomId },
      })
      .then((response) => response.data);
  }

  static sendUserData(
    id: string,
    courseId: string,
    contentUserData: any
  ): void {
    const url = `/xapi/${id}/courses/${courseId}/userdata`;
    api().post(url, contentUserData, {
      params: { classroomId: H5pRest.classroomId },
    });
  }

  static sendQuizData(data: QuizData): void {
    const url = `/xapi/quiz`;
    api().post(url, data, {
      params: { classroomId: H5pRest.classroomId },
    });
  }
}
